import React from "react";
import {
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  Grid,
  Link,
} from "@mui/material";
import styles from "./specialBlog.module.css";
import MyAppBar from "../../components/MyAppBar";

interface BlogContentDetail {
  title: string;
  content: string;
}

interface BlogSection {
  content: BlogContentDetail[];
  description: string;
  imageLink: string;
  redirectLink: string;
}

interface BlogData {
  id: string;
  title: string;
  titleImage: string;
  question: string;
  answer: string;
  points: string[];
  ended: string;
  duration: string;
  created: string;
  content: { [key: string]: BlogSection };
  keywords: string[];
}

const SpecialBlog: React.FC<{ blogEntry: BlogData }> = ({ blogEntry }) => {

  // const blogEntry = specialBlogData.find((blog) => blog.id === blogId);

  const { 
    title, 
    content,
    question,
    titleImage,
    duration, 
    created,
    answer,
    points,
    ended 
  } = blogEntry;

  const sectionTitles = Object.keys(content).map((key) =>
    key.split(/(?=[A-Z])/).join("")
  );

  return (
    <Box>
      <MyAppBar />
      <Box className={styles.blogHeader}>
        <Box className={styles.leftSide}>
          <img src={titleImage} alt=""/>
        </Box>
        <Box className={styles.rightSide}>
          <h1 className={styles.title}>{title}</h1>
          <br/>
          <Box className={styles.metaInfo}>
            <Typography variant="body2">{created}</Typography>
            <Typography variant="body2">{duration}</Typography>
          </Box>
          <br/>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              marginTop: "10px",
            }}
          >
            <IconButton aria-label="Twitter" sx={iconStyle} href="https://www.tiktok.com/@rentbabe/" target="_blank">
              <img src={"https://images.rentbabe.com/BLOG/ICONS/tiktok.svg"} width="24" height="24" alt="" />
            </IconButton>
            <IconButton aria-label="Instagram" sx={iconStyle} href="https://www.instagram.com/rentbabeofficial/" target="_blank">
              <img src={"https://images.rentbabe.com/BLOG/ICONS/insta.svg"} width="24" height="24" alt="" />
            </IconButton>
          </Box>
        </Box>
      </Box>

      <article className={styles.mainContent}>
        <Grid container spacing={2} className={styles.mainGrid}>
          <Typography
            className={styles.question}
            sx={typographyStyle}
          >
            {question}
          </Typography>
          
          <Box sx={{margin: "0px 20px"}}>

            <Typography paragraph>
              {answer}
            </Typography>

            <List  sx={{ margin: '0 20px', padding: '0', listStylePosition: 'inside' }}>
              {points.map((point, index) => (
                <ListItem key={index} sx={{
                  paddingLeft: "20px", 
                  display: "list-item", 
                  listStyleType: 'disc',
                  listStylePosition: 'inside'
                }}>
                  <Typography 
                    component="span"
                    dangerouslySetInnerHTML={{ __html: point }} 
                  />
                </ListItem>
              ))}
            </List>
            <br/>
            <Typography
              paragraph
            >
              {ended}
          </Typography>

          </Box>

          <Grid item xs={12} md={8}>
            {sectionTitles.map((keyValue, index) => {
              // sectionTitles : '1. RentBabe'

              interface contentProps {
                title: string,
                content: string
              }

              const paragraphData = content[keyValue];
              const contentData = paragraphData.content as contentProps[];
              const description = paragraphData.description;
              const imageLink = paragraphData.imageLink;
              const redirectLink = paragraphData.redirectLink;

              const key = Object.keys(content)[index];
              const sectionData = content[key];
              // const title = sectionData.title;
              const isComplexSection =
                typeof sectionData === "object" &&
                sectionData !== null &&
                sectionData.description;

              return (
                <Box
                  key={keyValue}
                  id={keyValue.replace(/\s+/g, "").toLowerCase()}
                  className={styles.contentSection}
                >
                  <Box
                    className={styles.sectionHeader}
                    sx={{
                      cursor: redirectLink ? "pointer" : "auto",
                      "&:hover": {
                        fontWeight: "bold",
                        fontSize: "1.2em" // Adjust the font size as needed
                      }
                    }}
                    onClick={() =>
                      {if(redirectLink) window.open(sectionData.redirectLink, "_blank")}
                    }
                  >
                    <Typography variant="h4" className={styles.sectionTitle}>
                      {keyValue}
                    </Typography>
                  </Box>
                  {isComplexSection ? (
                    <>
                      <Typography paragraph>
                        {description}
                      </Typography>

                    {
                      contentData.map((value) => {
                        const title = value.title
                        const description = value.content
                        return <>

                            <Typography
                              variant="h6"
                              className={styles.sectionTitle}
                              sx={{ fontWeight: "bold" }}
                            >
                              {title}
                            </Typography>
                            <Typography paragraph>
                              {description.split('\n').map((line, index) => (
                                <React.Fragment key={index}>
                                  {line}
                                  <br />
                                </React.Fragment>
                              ))}
                            </Typography>
                        </>
                      })
                    }


                      {imageLink && (
                        <Box
                          component="img"
                          src={imageLink}
                          alt={keyValue}
                          style={{ width: "100%", marginTop: "10px" }}
                          sx={{
                            border: "1px solid #ccc",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                            borderRadius: "8px",
                          }}
                          onClick={() =>
                            {if(redirectLink) window.open(redirectLink, "_blank")}
                          }
                        />
                      )}
                    </>
                  ) : (
                    <Typography paragraph>{sectionData}</Typography>
                  )}
                </Box>
              );
            })}
          </Grid>

          <Grid item xs={12} md={4}>
            <Box className={styles.tableOfContents} sx={tableOfContentsStyles}>
              <Typography
                variant="h5"
                style={{ marginBottom: "20px", fontWeight: "bold" }}
              >
                Contents
              </Typography>
              <List>
                {sectionTitles.map((title) => (
                  <ListItem key={title} component="div" sx={listItemStyles}>
                    <Link
                      href={`#${title.replace(/\s+/g, "").toLowerCase()}`}
                      color="inherit"
                      underline="hover"
                      onClick={(event) => {
                        event.preventDefault();
                        const section = document.getElementById(
                          title.replace(/\s+/g, "").toLowerCase()
                        );
                        section?.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        });
                      }}
                    >
                      {title}
                    </Link>
                  </ListItem>
                ))}
              </List>
            </Box>
          </Grid>

          <Grid item xs={12} md={8}>
            <Typography sx={typographyStyle}>Boost Your Social Life and Income with RentBabe</Typography>
            <Typography paragraph>Join RentBabe, the pioneering remote job platform that's truly one-of-a-kind. Experience a market like no other and seize the opportunity to monetize this rent-a-friend market.</Typography>
          </Grid>

        </Grid>
      </article>
    </Box>
  );
};

const iconStyle = {
  border: "2px solid black",
  borderRadius: "50%",
  "&:hover": {
    transform: "scale(1.15)",
    border: "2px solid white",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
    backgroundColor: "#c6187e",
  },
};

const typographyStyle = {
  fontSize: "3rem",
  fontFamily: "inherit",
  fontWeight: "bold",
  color: "black",
  textAlign: "center",
  margin: "20px 0",
  maxWidth: "100%",
  padding: "30px",
  "@media (max-width: 600px)": {
    fontSize: "1.5rem",
  },
  "@media (max-width: 400px)": {
    fontSize: "1.5rem",
  },
};

const tableOfContentsStyles = {
  position: "sticky",
  top: "100px",
  border: "2px solid #ccc",
  borderRadius: "10px",
  padding: "10px",
  backgroundColor: "#f8f8f8",
  boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
  "&:hover": {
    backgroundColor: "#f0f0f0",
  },
};

const listItemStyles = {
  fontFamily: "Georgia, serif",
  fontSize: "1.0rem",
  fontWeight: "400",
  border: "1px solid #ccc",
  borderradius: "10px",
  padding: "8px",
  margin: "10px 0",
  "&:hover": {
    color: "#c6187e",
    cursor: "pointer",
    transform: "scale(1.05)",
  },
};

export default SpecialBlog;
